import React from "react";

// Let children know they are in a list context
type IsWireComponentInCollection = false | { hasAction: boolean; onClick: () => void };
export const IsWireComponentInCollectionContext = React.createContext<IsWireComponentInCollection>(false);

export const useWireComponentInCollection = () => React.useContext(IsWireComponentInCollectionContext);
